import React, { useEffect } from 'react';
import './QuestionStep/style/StepCounter.css'

import { useHistory } from 'react-router-dom'

const StepCounter = () => {
    const thePath = document.URL;
    const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1);

    const next = () => {
        const getSpanById = document.getElementById(`${lastItem}`);
        getSpanById.setAttribute("style", "background-color: rgb(25, 163, 255);");
    }
    useEffect(() => {
        next();
    })
    const history = useHistory();

    return (
        <div className="step-container">
            <span onClick={() => (history.push(`/Q/1`))} id="1" className="dot"></span>
            <span onClick={() => (history.push(`/Q/2`))} id="2" className="dot"></span>
            <span onClick={() => (history.push(`/Q/3`))} id="3" className="dot"></span>
            <span onClick={() => (history.push(`/Q/4`))} id="4" className="dot"></span>
            <span onClick={() => (history.push(`/Q/5`))} id="5" className="dot"></span>
            <span onClick={() => (history.push(`/Q/6`))} id="6" className="dot"></span>
            <span onClick={() => (history.push(`/Q/7`))} id="7" className="dot"></span>
            <span onClick={() => (history.push(`/Q/8`))} id="8" className="dot"></span>
            <span onClick={() => (history.push(`/Q/9`))} id="9" className="dot"></span>
            <span onClick={() => (history.push(`/Q/10`))} id="10" className="dot"></span>
            <span onClick={() => (history.push(`/Q/11`))} id="11" className="dot"></span>
            <span onClick={() => (history.push(`/Q/12`))} id="12" className="dot"></span>
        </div>

    )

}



export default StepCounter

